// compare页面 勾选游戏数量上限
export const MAXGAMENUM = 6;
